import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { t } from "i18next";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Input,
} from "reactstrap";
import { useSpaceStore } from "../../../../stores/Assets/space";
import { toast } from "react-toastify";

const AddSubSpace = ({
  menuIDs,
  kitchenID,
  space_id,
  showAddSubSpaceModal,
  toggleAddSubSpaceModal,
  onSubSpaceCreated,
}) => {
  const [subSpaceCount, setSubSpaceCount] = useState(0); // Default to 1
  const { createSubSpaces, isLoading } = useSpaceStore((state) => state);

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(t("Required")),
    }),
    onSubmit: async (values) => {
      try {
        const { name } = values;
        if (subSpaceCount < 1 || subSpaceCount > 100) {
          toast.error(t("Subspace count must be between 1 and 100"));
          return;
        }
        // Backend continues numbering from max existing `{base}#N` in this space
        const body = {
          base_name: name,
          count: subSpaceCount,
          space_id: parseInt(space_id),
        };

        const result = await createSubSpaces(
          space_id,
          body,
          kitchenID,
          menuIDs,
        );

        if (result) {
          formik.resetForm();
          toggleAddSubSpaceModal();
          // Call the callback to refresh the parent component
          if (onSubSpaceCreated) {
            onSubSpaceCreated();
          }
        } else {
          console.error("Failed to create subspaces");
        }
      } catch (error) {
        console.error("Error in form submission:", error);
      }
    },
  });

  return (
    <Modal isOpen={showAddSubSpaceModal} toggle={toggleAddSubSpaceModal}>
      <ModalHeader toggle={toggleAddSubSpaceModal}>
        {t("Add New SubSpaces")}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {/* Input for Base Name */}
          <Label htmlFor="name">{t("Base Name")}</Label>
          <Input
            id="name"
            name="name"
            type="text"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={
              formik.errors.name && formik.touched.name ? "is-invalid" : ""
            }
          />
          {formik.errors.name && formik.touched.name && (
            <div className="invalid-feedback">{formik.errors.name}</div>
          )}

          {/* Input for Subspace Count */}
          <Label htmlFor="subSpaceCount" className="mt-3">
            {t("Number of SubSpaces")}
          </Label>
          <Input
            id="subSpaceCount"
            name="subSpaceCount"
            type="number"
            value={subSpaceCount}
            onChange={(e) => {
              setSubSpaceCount(parseInt(e.target.value));
            }}
          />

          {/* Buttons */}
          <div className="d-flex justify-content-end mt-4 gap-3">
            <Button type="submit" color="success" disabled={isLoading}>
              {isLoading ? <Spinner size="sm" /> : t("Add")}
            </Button>
            <Button
              type="button"
              color="danger"
              onClick={() => {
                toggleAddSubSpaceModal();
                formik.resetForm();
              }}
              disabled={isLoading}
            >
              {t("Cancel")}
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default AddSubSpace;
